var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hide-scroll",staticStyle:{"padding-left":"100px","max-height":"calc(100vh - 120px)","min-height":"600px"}},[_c('SettingComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }